import { api } from "./api";

export const adminLogin = async (
  username: string,
  phone: string,
  password: string
) => {
  try {
    const res = await api.post(`/login`, {
      username,
      password,
      phone,
    });
    return res;
  } catch (error) {
    return error;
  }
};
export const adminLogout = async (token: string) => {
  try {
    const res = await api.post(`/logout`, {
      token,
    });
    return res;
  } catch (error) {
    return error;
  }
};

export const adminAuthStatus = async (token: string) => {
  try {
    const res = await api.post(`/status`, {
      token,
    });
    return res;
  } catch (error) {
    return error;
  }
};

export const createAdminUser = async ({
  name,
  phone,
  username,
  password,
}: any) => {
  try {
    const res = await api.post(`/admin-user`, {
      username,
      name,
      phone,
      password,
    });
    return res;
  } catch (error) {
    return error;
  }
};

export const getAdminUsersList = async ({
  pageNumber,
  limit,
}: {
  pageNumber?: number;
  limit?: number;
}) => {
  try {
    const params: Record<string, any> = {};
    if (pageNumber !== undefined) params.pageNumber = pageNumber;
    if (limit !== undefined) params.limit = limit;

    const res = await api.get(`/admin-user/list`, { params });
    return res;
  } catch (error) {
    return error;
  }
};

export const getAdminUserById = async ({ id }: any) => {
  try {
    const res = await api.get(`/admin-user?_id=${id}`);
    return res;
  } catch (error) {
    return error;
  }
};

export const deleteAdminUserById = async ({ id }: any) => {
  try {
    const res = await api.delete(`/admin-user`, {
      data: { _id: id },
    });
    return res;
  } catch (error) {
    return error;
  }
};

export const updateAdminUserById = async ({ id, updates }: any) => {
  try {
    const res = await api.put(`/admin-user`, {
      _id: id,
      ...updates,
    });
    return res;
  } catch (error) {
    console.error("Error updating user:", error);
    return error;
  }
};
